export default function(){
    return $(`
<div class="row" style="margin-top: 25px;">
    <div class="col-md-6">
        <div class="ibox">
            <div class="ibox-content">
                <div class="row">
                    <div class="col-md-12">
                        <hr style="margin: 6px 0px;" />
                        <div class="row">
                            <div class="col-md-5">
                                <span class="placeholder">Conta</span>
                            </div>
                            <div class="col-md-7">
                                <span class="placeholder">00001</span>
                            </div>
                        </div>
                        <hr style="margin: 6px 0px;" />
                        <div class="row">
                            <div class="col-md-5">
                                <span class="placeholder">Ponto de Caixa</span>
                            </div>
                            <div class="col-md-7">
                                <span class="placeholder">Recepção (1)</span>
                            </div>
                        </div>
                        <hr style="margin: 6px 0px;" />
                        <div class="row">
                            <div class="col-md-5">
                                <span class="placeholder">Operador</span>
                            </div>
                            <div class="col-md-7">
                                <span class="placeholder">###########</span>
                            </div>
                        </div>
                        <hr style="margin: 6px 0px;" />
                        <div class="row">
                            <div class="col-md-5">
                                <span class="placeholder">Observações</span>
                            </div>
                            <div class="col-md-7">
                                <span class="placeholder"></span>
                            </div>
                        </div>
                        <hr style="margin: 6px 0px;" />
                        <div class="row">
                            <div class="col-md-5">
                                <span class="placeholder">Estadia</span>
                            </div>
                            <div class="col-md-7">
                                <span class="placeholder"></span>
                            </div>
                        </div>
                        <hr style="margin: 6px 0px;" />
                        <div class="row">
                            <div class="col-md-5">
                                <span class="placeholder">Método</span>
                            </div>
                            <div class="col-md-7">
                                <span class="placeholder">Cartão</span>
                            </div>
                        </div>
                        <hr style="margin: 6px 0px;" />
                        <div class="row">
                            <div class="col-md-5">
                                <span class="placeholder">Horário</span>
                            </div>
                            <div class="col-md-7">
                                <span class="placeholder">19 de Setembro de 2024 às 07:47</span>
                            </div>
                        </div>
                        <hr style="margin: 6px 0px;" />
                        <div class="row">
                            <div class="col-md-5">
                                <span class="placeholder">Data Prevista</span>
                            </div>
                            <div class="col-md-7">
                                <span class="placeholder">19 de Setembro de 2024</span>
                            </div>
                        </div>
                        <hr style="margin: 6px 0px;" />
                        <div class="row">
                            <div class="col-md-5">
                                <span class="placeholder">Tipo</span>
                            </div>
                            <div class="col-md-7">
                                <span class="placeholder">Entrada</span>
                            </div>
                        </div>
                        <hr style="margin: 6px 0px;" />
                        <div class="row">
                            <div class="col-md-5">
                                <span class="placeholder">Valor</span>
                            </div>
                            <div class="col-md-7">
                                <span class="placeholder">R$ 125,00</span>
                            </div>
                        </div>
                        <hr style="margin: 6px 0px;" />
                        <div class="row">
                            <div class="col-md-5">
                                <span class="placeholder">Taxa (%)</span>
                            </div>
                            <div class="col-md-7">
                                <span class="placeholder">0,0 %</span>
                            </div>
                        </div>
                        <hr style="margin: 6px 0px;" />
                        <div class="row">
                            <div class="col-md-5">
                                <span class="placeholder">Taxa (R$)</span>
                            </div>
                            <div class="col-md-7">
                                <span class="placeholder">R$ 0,00</span>
                            </div>
                        </div>
                        <hr style="margin: 6px 0px;" />
                        <div class="row">
                            <div class="col-md-5">
                                <span class="placeholder">Valor final</span>
                            </div>
                            <div class="col-md-7">
                                <span class="placeholder">R$ 125,00</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-4">
        <div class="ibox">
            <div class="ibox-content">
                <div class="row">
                    <div class="col-md-12">
                        <h3 class="placeholder">Selecionar um ponto de caixa</h3>
                        <a href="#" class="btn btn-primary btn btn-block btn-primary btn-hotelf placeholder" style="border: 0">Compensar Pagamento</a>
                        <a href="#" class="btn btn-primary btn btn-block btn-primary btn-hotelf placeholder" style="border: 0">Compensar Pagamento</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>`)
}